import type { FormEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import { selectOrganizationsOptInSms } from '@/containers/OrganizationsManagement/organizationsManagementSelectors'
import { organizationsManagementActions } from '@/containers/OrganizationsManagement/organizationsManagementSagas'
import { closeOptInSms, setOptInSmsDraft } from '@/containers/OrganizationsManagement/organizationsManagementSlice'

const useOptInSmsModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { isOpen, draft, saving } = useSelector(selectOrganizationsOptInSms)

  const onClose = () => dispatch(closeOptInSms())
  const onDraftChange = (event: FormEvent<HTMLTextAreaElement>) => dispatch(setOptInSmsDraft(event.currentTarget.value))
  const onSave = () => dispatch({ type: organizationsManagementActions.SAVE_OPT_IN_SMS_TEXT, enqueue })

  return { t, isOpen, draft, saving, onClose, onDraftChange, onSave }
}

export default useOptInSmsModal
